<template>
  <div>
    <div v-if="!listings">
      <div v-for="(t,i) in tsks" :key="i" class="pd-l-5">
          <div @click="$emit('show-task', t.task.id)" role="button" v-if="fromMe" :class="` text-white d-flex`">
            <div class="mg-l-auto bg-info pd-5 rounded">{{t.task.task}}</div>
            
          </div>
          <div @click="$emit('show-task', t.task.id)" role="button" v-else :class="`bg-light rounded d-flex pd-5`">
            <feather type="clipboard"></feather>
            {{t.task.task}}
            <div class="tx-11 mg-l-auto text-muted">{{t.task.title}}</div>
          </div>
      </div>
    </div>
    <div v-else class="pd-20">
      <ul class="list-group">
        <li @click="$emit('show-task', t.id)" role="button" v-for="(t,i) in tsks" :key="i" class="list-group-item d-flex">
          {{t.task}}
          <span class="mg-l-auto text-muted tx-12">{{t.objectType.name}}</span>
          <!-- <span class="mg-l-auto text-muted tx-12">{{t.project.name}}/{{t.objectType.name}}</span> -->
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props:{
    tsks: {
      type: Array,
      default: () => [],
    },
    fromMe:{
      type: Boolean,
      default: () => false,
    },
    listings:{
      type: Boolean,
      default: () => false,
    },
  }
}
</script>

<style>

</style>